import { render, staticRenderFns } from "./ChartConfigurator.vue?vue&type=template&id=319854d2&"
import script from "./ChartConfigurator.vue?vue&type=script&lang=js&"
export * from "./ChartConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports